import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a944cf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["aria-label"]

import {ref, withDefaults} from 'vue'
import router from "@/router";
import i18n from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'SwitchButton',
  props: {
    title: null,
    ariaLabel: { default: '' },
    modelValue: { type: Boolean },
    labelMaxWidth: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (__props.disabled)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "flex items-center",
        tabindex: "0",
        "aria-label": __props.ariaLabel
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["switch", {'active': __props.modelValue}])
        }, null, 2),
        _createElementVNode("span", {
          class: _normalizeClass(["text-light-secondary", {'w-max': __props.labelMaxWidth}])
        }, _toDisplayString(__props.title), 3)
      ], 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "flex items-center",
        onKeydown: _cache[0] || (_cache[0] = _withKeys((event) => _ctx.$emit('update:modelValue', !__props.modelValue), ["enter"])),
        onClick: _cache[1] || (_cache[1] = (event) => _ctx.$emit('update:modelValue', !__props.modelValue)),
        tabindex: "0",
        onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.toggleSwitch = !_ctx.toggleSwitch), ["enter"])),
        "aria-label": __props.ariaLabel
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["switch", {'active': __props.modelValue}])
        }, null, 2),
        _createElementVNode("span", {
          class: _normalizeClass(["text-light-secondary", {'w-max': __props.labelMaxWidth}])
        }, _toDisplayString(__props.title), 3)
      ], 40, _hoisted_2))
}
}

})